<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <vc-select color="primary" name="ranges" v-model="defaultRange" :items="ranges" />
    <h3 :class="['subheading', 'font-grey', 'font-l-600']">
      <span>{{ npm.start }}</span><span v-if="npm.start !== npm.end"> - </span><span v-if="npm.start !== npm.end">{{ npm.end }}</span>
    </h3>
    <vc-list>
      <vc-list-item v-for="(download, index) in npm.downloads" :key="index" avatar="mdi-npm">
        <vc-list-item-primary-text>
          <strong :class="['font-primary']">{{ download.downloads }}</strong>
        </vc-list-item-primary-text>
        <vc-list-item-secondary-text>{{ download.day.split('-').join('/') }}</vc-list-item-secondary-text>
      </vc-list-item>
    </vc-list>
  </div>
</template>
<script>
export default {
  name: 'DownloadsPage',
  data () {
    return {
      title: 'NPM Downloads',
      description: null,
      npm: null,
      defaultRange: [],
      ranges: [{
        label: 'Last day',
        value: 'last-day'
      }, {
        label: 'Last week',
        value: 'last-week'
      }, {
        label: 'Last month',
        value: 'last-month'
      }]
    }
  },
  watch: {
    defaultRange () {
      this.getNpmDownloads()
    }
  },
  created () {
    this.defaultRange.push(this.ranges[1])
  },
  methods: {
    getNpmDownloads () {
      const root = this.$root
      const events = this.$store.state.events
      const url = `https://api.npmjs.org/downloads/range/${this.defaultRange[0].value}/vuecidity`
      root.$emit(events.ajaxStart)
      this.$http(url).then(response => {
        response = response.data
        response.start = response.start.split('-').join('/')
        response.end = response.end.split('-').join('/')
        response.downloads = response.downloads.reverse()
        this.npm = response
        root.$emit(events.ajaxEnd)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/downloads.vue